<template>
    <footer class="py-4 bg-light mt-auto hide-on-print">
        <div class="container-fluid">
            <div class="d-flex align-items-center justify-content-between small">
                <div class="font-weight-bold">Copyright &copy; TNKC Online Booking 2023</div>
                <div>
                    <a href="#">Privacy Policy</a>
                    &middot;
                    <a href="#">Terms &amp; Conditions</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style scoped>

</style>
